// removed by extract-text-webpack-plugin
module.exports = {"btn-back":"AutosaggestPopin-module-btn-back-1t6df","btnBack":"AutosaggestPopin-module-btn-back-1t6df","focused-input-field":"AutosaggestPopin-module-focused-input-field-3UELr","focusedInputField":"AutosaggestPopin-module-focused-input-field-3UELr","label":"AutosaggestPopin-module-label-UscK0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AutosaggestPopin/AutosaggestPopin.module.scss
// module id = 978
// module chunks = 0